
// Inject Floating Checkout Bar HTML, CSS, and behavior
(() => {
  // Do not run on cart or checkout pages
  if (
    window.location.pathname === '/cart' ||
    window.location.pathname.startsWith('/checkout')
  ) return;

  // Prevent duplicate injection
  if (document.getElementById('sunaanCheckoutBar')) return;

  // Inject HTML + CSS
  const html = `
  <style>
    .sunaan-floating-checkout {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      background: #fff;
      border-top: 1px solid #ddd;
      padding: 16px;
      z-index: 10;
      box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
      display: none;
    }

    .sunaan-checkout-inner {
      max-width: 1100px;
      margin: 0 auto;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-wrap: wrap;
      gap: 16px;
    }

    .sunaan-cart-summary {
      display: flex;
      flex-direction: column;
      gap: 4px;
      flex: 1;
      min-width: 180px;
    }

    .sunaan-cart-summary h3 {
      margin: 0;
      font-size: 16px;
      font-weight: 600;
    }

    .sunaan-subtotal-line {
      display: flex;
      gap: 6px;
      align-items: center;
      flex-wrap: wrap;
    }

    .sunaan-cart-summary .sunaan-subtotal-label {
      color: #4B4F55;
    }

    .sunaan-cart-summary .sunaan-subtotal-amount {
      color: #043B36;
    }

    .sunaan-button-row {
      display: flex;
      gap: 12px;
      flex: 1;
      justify-content: flex-end;
    }

    .sunaan-checkout-button,
    .sunaan-viewcart-button {
      padding: 12px 16px;
      font-size: 16px;
      font-weight: 600;
      border: none;
      border-radius: 4px;
      display: flex;
      align-items: center;
      gap: 10px;
      cursor: pointer;
    }

    .sunaan-checkout-button {
      background-color: #000;
      color: #fff;
    }

    .sunaan-viewcart-button {
      background: none;
      color: #000;
      text-decoration: underline;
    }

    .sunaan-checkout-button img {
      height: 20px;
      width: auto;
    }

    @media (max-width: 768px) {
      .sunaan-cart-summary,
      .sunaan-viewcart-button {
        display: none;
      }

      .sunaan-checkout-inner {
        justify-content: center;
      }

      .sunaan-checkout-button {
        width: 100%;
        justify-content: center;
        flex-grow: 1;
      }
    }
  </style>

  <div class="sunaan-floating-checkout" id="sunaanCheckoutBar">
    <div class="sunaan-checkout-inner">
      <div class="sunaan-cart-summary">
        <h3 id="sunaanItemCount"></h3>
        <div class="sunaan-subtotal-line">
          <h3 class="sunaan-subtotal-label">Subtotal</h3>
          <h3 class="sunaan-subtotal-amount" id="sunaanSubtotal"></h3>
        </div>
      </div>
      <div class="sunaan-button-row">
        <button class="sunaan-viewcart-button" type="button">View Cart</button>
        <button class="sunaan-checkout-button" type="button">
          <img src="https://cdn.shopify.com/s/files/1/0757/4021/7672/files/ShoppingCartSimple.svg?v=1753615321" alt="Cart Icon" />
          <span id="sunaanCheckoutText">Checkout</span>
        </button>
      </div>
    </div>
  </div>
  `;

  document.body.insertAdjacentHTML('beforeend', html);

  const bar = document.getElementById('sunaanCheckoutBar');
  const itemCountEl = document.getElementById('sunaanItemCount');
  const subtotalEl = document.getElementById('sunaanSubtotal');
  const labelEl = document.getElementById('sunaanCheckoutText');
  const viewCartBtn = document.querySelector('.sunaan-viewcart-button');
  const checkoutBtn = document.querySelector('.sunaan-checkout-button');

  if (!bar || !checkoutBtn) return;

  // Buttons
  viewCartBtn.addEventListener('click', () => {
    window.location.href = '/cart';
  });

  function setCheckoutBehavior() {
    if (window.innerWidth <= 768) {
      labelEl.textContent = 'Continue to Cart';
      checkoutBtn.onclick = () => window.location.href = '/cart';
    } else {
      labelEl.textContent = 'Checkout';
      checkoutBtn.onclick = () => window.location.href = '/checkout';
    }
  }

  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.Shopify.money_format);
    }
    return (cents / 100).toFixed(2);
  }

  function isCartDrawerOpen() {
    const drawer =
      document.querySelector('cart-drawer') ||
      document.querySelector('#CartDrawer') ||
      document.querySelector('[id*="CartDrawer"]');

    if (!drawer) return false;

    const aria = drawer.getAttribute('aria-hidden');
    if (aria === 'false') return true;
    if (drawer.hasAttribute('open')) return true;
    if (drawer.classList.contains('active') || drawer.classList.contains('is-open')) return true;

    return false;
  }

  async function updateBar() {
    if (isCartDrawerOpen()) {
      bar.style.display = 'none';
      return;
    }

    try {
      const res = await fetch('/cart.js', { credentials: 'same-origin' });
      const cart = await res.json();

      if (cart.item_count > 0) {
        itemCountEl.textContent = `${cart.item_count} item${cart.item_count > 1 ? 's' : ''}`;
        subtotalEl.textContent = formatMoney(cart.total_price);
        setCheckoutBehavior();
        bar.style.display = 'block';
      } else {
        bar.style.display = 'none';
      }
    } catch {
      bar.style.display = 'none';
    }
  }

  // Initial run after page ready
  window.addEventListener('load', updateBar);

  // Resize updates button behavior
  window.addEventListener('resize', () => setCheckoutBehavior());

  // After add-to-cart submits
  document.addEventListener('submit', (e) => {
    const form = e.target;
    if (form && typeof form.action === 'string' && form.action.includes('/cart/add')) {
      setTimeout(updateBar, 600);
    }
  }, true);

  // Listen for theme cart events if present
  document.addEventListener('cart:refresh', () => setTimeout(updateBar, 150));
  document.addEventListener('cart:updated', () => setTimeout(updateBar, 150));

  // Observe drawer state
  const drawer =
    document.querySelector('cart-drawer') ||
    document.querySelector('#CartDrawer') ||
    document.querySelector('[id*="CartDrawer"]');

  if (drawer) {
    const obs = new MutationObserver(() => updateBar());
    obs.observe(drawer, { attributes: true, attributeFilter: ['class', 'open', 'aria-hidden'] });
  }

})();
